<hpf-game-form
        [game]="game"
        [loading]="game.isNew()"
        (update)="onUpdate()"
        (delete)="onDelete()"
    ></hpf-game-form>
<div class="container">
</div>
